import React, { useRef, useEffect } from 'react'
import { useDebounce } from 'react-use'
const PDFJSViewer = require('pdfjs-dist/web/pdf_viewer')

const isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1
const isMSEdgeOrIE = Boolean(window.MSInputMethodContext)
const isEnhancedTextSelectionEnabled = isFirefox === false && isMSEdgeOrIE === false

const areEqual = (prevProps, nextProps) => {
  return (
    prevProps.viewportHeight === nextProps.viewportHeight &&
    prevProps.viewportWidth === nextProps.viewportWidth &&
    prevProps.pageNumber === nextProps.pageNumber &&
    prevProps.textContent === nextProps.textContent
  )
}

function TextLayer({ viewportHeight, viewportWidth, pageNumber, viewport, textContent }) {
  const div = useRef(null)

  const handleTextLayerRender = (event) => {
    const isDifferentPage = event.source.pageNumber - 1 !== pageNumber
    if (isDifferentPage) {
      return
    }

    Array.from(div.current.children).forEach((element, _index) => {
      // hack for IE and edge, https://github.com/mozilla/pdf.js/issues/5513
      if (isMSEdgeOrIE) {
        element.style.marginLeft = element.style.left
        element.style.marginTop = element.style.top
        element.style.float = 'left'
        element.style.marginBottom = '-100%'
        element.style.marginRight = '-100%'
      } else {
        element.classList.add('textLayer--absolute')
      }
    })
  }

  const renderTextLayer = () => {
    deleteAllChildNodes(div.current)
    const eventBus = new PDFJSViewer.EventBus()
    eventBus.on('textlayerrendered', (event) => {
      handleTextLayerRender(event)
    })
    const textLayer = new PDFJSViewer.TextLayerBuilder({
      textLayerDiv: div.current,
      eventBus,
      pageIndex: pageNumber,
      viewport: viewport,
      enhanceTextSelection: isEnhancedTextSelectionEnabled,
    })
    textLayer.setTextContent(textContent)
    textLayer.render(200)
  }

  const renderTextLayerRequest = useRef(null)
  useEffect(() => {
    renderTextLayer()
  })
  useDebounce(
    () => {
      renderTextLayerRequest.current = window.requestAnimationFrame(renderTextLayer)
    },
    200,
    [viewportHeight, viewportWidth, pageNumber, textContent],
  )

  return (
    <div
      className="TextLayer-container"
      style={{
        height: `${viewportHeight}px`,
        width: `${viewportWidth}px`,
        position: 'absolute',
        left: 0,
        top: 0,
      }}
    >
      <div className="textLayer" ref={div} />
    </div>
  )
}

function deleteAllChildNodes(node) {
  while (node.firstChild) {
    node.removeChild(node.firstChild)
  }
}

export default React.memo(TextLayer, areEqual)
